var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 1.19922L18 8.39922V20.2792C18 21.671 16.8718 22.7992 15.48 22.7992H2.52C1.12824 22.7992 0 21.671 0 20.2792V3.71922C0 2.32746 1.12824 1.19922 2.52 1.19922H10.8Z",
    fill: "#E94848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39404 9.11914C7.92213 9.11914 7.53404 9.50723 7.53404 9.97914C7.53404 10.5658 7.85999 11.2941 8.20323 11.9786C7.93493 12.8185 7.63048 13.7185 7.2411 14.478C7.10007 14.5334 6.96173 14.5862 6.82719 14.6376C6.20147 14.8765 5.65779 15.0841 5.3061 15.3676C5.29944 15.3744 5.29316 15.3816 5.28729 15.3891C5.13114 15.5488 5.04004 15.7662 5.04004 15.9991C5.04004 16.471 5.42813 16.8591 5.90004 16.8591C6.13016 16.8591 6.35228 16.7733 6.51279 16.6092C6.51834 16.6049 6.52372 16.6005 6.52891 16.5958C6.84346 16.2202 7.21434 15.5388 7.54479 14.9161C8.30638 14.6165 9.10461 14.3116 9.87485 14.1286C10.4371 14.5818 11.2506 14.8811 11.92 14.8811C12.3919 14.8811 12.78 14.493 12.78 14.0211C12.78 13.5492 12.3919 13.1611 11.92 13.1611C11.3832 13.1611 10.603 13.3528 10.0065 13.5535C9.52304 13.0996 9.07882 12.5327 8.75954 11.9303C8.79404 11.824 8.82942 11.7177 8.86462 11.6119L8.86463 11.6119L8.86465 11.6118L8.86466 11.6118C9.06217 11.0183 9.25404 10.4419 9.25404 9.97914C9.25404 9.50723 8.86595 9.11914 8.39404 9.11914ZM8.39408 9.63531C8.58712 9.63531 8.73808 9.78627 8.73808 9.97931C8.73808 10.2374 8.59986 10.7127 8.43977 11.2236C8.22585 10.7266 8.05008 10.2497 8.05008 9.97931C8.05008 9.78627 8.20104 9.63531 8.39408 9.63531ZM9.43404 13.712C9.10339 13.3722 8.80045 12.9893 8.54179 12.5779C8.36187 13.1254 8.17182 13.6814 7.93441 14.2173C8.42595 14.0302 8.92404 13.8515 9.43404 13.712ZM11.9199 13.6772C12.113 13.6772 12.2639 13.8282 12.2639 14.0212C12.2639 14.2143 12.113 14.3652 11.9199 14.3652C11.5324 14.3652 10.9816 14.1903 10.5413 13.946C11.0467 13.8031 11.5982 13.6772 11.9199 13.6772ZM6.13642 16.2544C6.30456 16.0517 6.54495 15.6488 6.78679 15.2171C6.28794 15.4167 5.84904 15.6038 5.64729 15.7599C5.59453 15.8181 5.55592 15.9083 5.55592 15.9991C5.55592 16.1922 5.70688 16.3431 5.89992 16.3431C6.00257 16.3431 6.07898 16.3094 6.13642 16.2544Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_178_10249)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.39844H13.4473C12.0555 8.39844 10.8 7.14292 10.8 5.75116V1.19844L18 8.39844Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_178_10249",
    x: 10.4398,
    y: 0.479219,
    width: 7.9202,
    height: 7.91922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.18
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0909637 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_178_10249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_178_10249",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/IconPdf.ad388b60094474f7843c59ff0e4248ce.svg";
export { ForwardRef as ReactComponent };